(function () {
    'use strict';

    angular.module("imApp").factory("stockTransferLoadService", ['$ihttp', function ($ihttp) {
        let service = {
            getStockTransferLoad: function (parms) {
                return $ihttp.post({
                    method: 1036,
                    parameters: parms || {}
                });
            },
            pickFinishedObj: function (setting) {
                return $ihttp.post({
                    method: 1040,
                    parameters: setting
                });
            }
        };

        return service;
    }]);
})();
